class Logger {

    trackException(e: Error): void  {
        window.appInsights.trackException(e);
    }

    setUserAndAccount(userId: string, accountId: string): void {
        window.appInsights.setAuthenticatedUserContext(userId, accountId);
    }
}

const teamLogger = new Logger();

export { teamLogger };